import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { isMiniSize, openLink } from "@/utils";
import { api } from "@/utils/api";
import localforage from "localforage";
import PropTypes from "prop-types";

import AuthImage from "@/react-components/AuthImage";
import PdfFileItem from "@/react-components/PdfFileItem";
import { libraryTypeEnum, reportTypeEnum } from "@/utils/enum";
import { isDisconnected, sitecoreApiHost } from "@/util";
import { isEmpty, substringEllipsis } from "@/utils";

class ArticleItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdfFile: "",
      showHotBadgeDate: null,
    };
  }

  componentDidMount() {
    this.getRealPdf();
    this.getShowHotBadgeDate();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.articles?.link !== this.props.articles?.link) {
      this.getRealPdf();
    }
  }

  getRealPdf = () => {
    const { articles } = this.props;
    if (articles.libraryType === libraryTypeEnum.pdf) {
      const path = articles.link.split("key=");
      if (path.length > 1) {
        const key = path[1];
        localforage
          .getItem(key)
          .then((value) => {
            if (value) {
              this.setState({
                pdfFile: URL.createObjectURL(value),
              });
            } else {
              api.image
                .getByKey({ key })
                .then((response) => {
                  localforage.setItem(key, response).catch((error) => {
                    console.error(error);
                  });
                  this.setState({
                    pdfFile: URL.createObjectURL(response),
                  });
                })
                .catch((error) => {
                  console.error("error: " + error.message);
                });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.setState({ pdfFile: articles.link });
      }
    } else {
      this.setState({ pdfFile: articles.link });
    }
  };

  click = (libraryType, link, id, title) => {
    const {
      history: { push },
    } = this.props;
    if (!libraryType || libraryType === libraryTypeEnum.page) {
      push(link);
    } else {
      openLink(this.state.pdfFile, id, libraryType, title);
    }
  };

  getData = () => {
    const { articles: article, t } = this.props;
    let date = article.publicDate;
    let prefix = "";
    let className = "";
    if (
      article.link.indexOf(reportTypeEnum.library) > -1 ||
      article.libraryType === libraryTypeEnum.pdf ||
      article.libraryType === libraryTypeEnum.link
    ) {
      if (article.updateDate !== article.publicDate) {
        date = article.updateDate;
        prefix = `${t("Library_kbn_update")}：`;
        className =
          article.libraryType === libraryTypeEnum.pdf ? "pdf-update" : "update";
      } else {
        prefix = `${t("Library_kbn_publish")}：`;
        className =
          article.libraryType === libraryTypeEnum.pdf
            ? "pdf-publish"
            : "publish";
      }
      className =
        article.libraryType === libraryTypeEnum.pdf
          ? className + " pickup-pdf-font-color"
          : className;
    }

    return { date, prefix, className };
  };

  getShowHotBadgeDate = () => {
    const { t } = this.props;
    api.common
      .getTime()
      .then((response) => {
        const showHotBadgeDate = new Date(response);
        const numberOfDaysOfHotResearch = parseInt(t("hot_research_number_of_days"));
        showHotBadgeDate.setDate(showHotBadgeDate.getDate() - numberOfDaysOfHotResearch);
        this.setState({ showHotBadgeDate });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const { showHotBadgeDate } = this.state;
    const { articles: article, isMultipleCategory } = this.props;
    const { date, prefix, className } = this.getData();
    const iconClass = isMiniSize()
      ? "pickup-pdf-icon-isMobile"
      : "pickup-pdf-icon";
    const imageSrc = isDisconnected
      ? `${sitecoreApiHost}${article.cover}`
      : article.cover;
    const showHotBadge = showHotBadgeDate !== null && new Date(article.publicDate) >= showHotBadgeDate && article.tags.indexOf("z2") !== -1;

    return (
      <div className="news-item">
        <div className="news-item-header">
          <div
            className={`news-item-img-wrapper ${
              article.libraryType === libraryTypeEnum.pdf
                ? "news-item-img-wrapper-border"
                : ""
            }`}
            onClick={() =>
              this.click(
                article.libraryType,
                article.link,
                article.id,
                article.title
              )
            }
            tabIndex="0"
          >
            {article.libraryType === libraryTypeEnum.pdf ? (
              <div className={iconClass}></div>
            ) : (
              <AuthImage
                className="news-item-img"
                src={imageSrc}
                isZoom={false}
                alt=""
              />
            )}
            {article.libraryType !== libraryTypeEnum.pdf && (
              <span className="timeMask" />
            )}
            <span className={`time ${className}`}>{`${prefix}${date
              .slice(0, 10)
              ?.replace(/-/g, ".")}`}</span>
            {showHotBadge && <AuthImage src={this.props.t("hot_research_icon")} className="hot-icon" isZoom={false} />}
          </div>
          <div className="news-item-title-wrap">
            {article.libraryType === libraryTypeEnum.pdf ||
            article.libraryType === libraryTypeEnum.link ? (
              <PdfFileItem
                pdfFile={article.link}
                pdfTitle={article.title}
                className="news-item-title"
                itemId={article.id}
                libraryType={article.libraryType}
              />
            ) : (
              <RouterLink className="news-item-title" to={article.link}>
                {article.title}
              </RouterLink>
            )}
            {!isMultipleCategory && article.catagory && (
              <div>
                <span className="news-item-label">{article.catagory}</span>
              </div>
            )}
            {isMultipleCategory &&
              article.tagModel &&
              article.tagModel.length > 0 && (
                <div className="news-item-label-container ellipsis-text">
                  {article.tagModel.map(
                    (item, index) =>
                      !isEmpty(item.text) && (
                        <span
                          key={index}
                          className="news-item-label single-line-text"
                        >
                          {substringEllipsis(item.text)}
                        </span>
                      )
                  )}
                </div>
              )}
          </div>
        </div>
        <div className="news-item-desc">
          <div className="news-item-desc-text">{article.summary}</div>
        </div>
      </div>
    );
  }
}

ArticleItem.propTypes = {
  isMultipleCategory: PropTypes.bool,
};

ArticleItem.defaultProps = {
  isMultipleCategory: true,
};

export default withRouter(withTranslation()(ArticleItem));
